/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_ANNOUNCEMENT_URL, API_TAG_URL, COMMON_HEADER_CONFIG} from "../config";

class StockService {
  getAccessToken = () => localStorage.getItem("accessToken");

  getListTag = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_TAG_URL}/tag`,
        params: {
          per_page: 10,
          page: 1,
          ...data
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getTag = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_TAG_URL}/tag/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createTag = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_TAG_URL}/tag`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateTag = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "put",
        url: `${API_TAG_URL}/tag/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.message);
          } else {
            reject(response.data.message);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteTag = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_TAG_URL}/tag/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data.code === 1 || response.data.code === "success") {
            resolve(response.data.code);
          } else {
            reject(response.data.code);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListTagType = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ANNOUNCEMENT_URL}/meta-data`,
        params: {
          type: "tag-type",
          platform_key: "centralweb"
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getTagRelationship = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_TAG_URL}/tag-relationship`,
        params: {
          ...data
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const stockService = new StockService();

export default stockService;
